module.exports = __webpack_public_path__ + "img/fail.40da2c30.svg";